import type { ThemeConfig } from 'antd';
import { theme } from 'antd';

export const getThemeConfig = (mode: 'light' | 'dark'): ThemeConfig => ({
  algorithm: mode === 'dark' ? theme.darkAlgorithm : theme.defaultAlgorithm,
  token: {
    colorPrimary: '#1B5FE3',
    colorSuccess: '#22C55E',
    colorWarning: '#F59E0B',
    colorError: '#EF4444',
    colorInfo: '#3B82F6',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    borderRadius: 8,
    controlHeight: 40,
    lineWidth: 1,
  },
  components: {
    Layout: {
      siderBg: mode === 'dark' ? '#141414' : '#001529',
      headerBg: mode === 'dark' ? '#1f1f1f' : '#ffffff',
      bodyBg: mode === 'dark' ? '#000000' : '#f3f4f6',
    },
    Menu: {
      darkItemBg: mode === 'dark' ? '#141414' : '#001529',
    },
    Table: {
      headerBg: mode === 'dark' ? '#1f1f1f' : '#fafafa',
      borderColor: mode === 'dark' ? '#303030' : '#e5e7eb',
    },
    Card: {
      paddingLG: 24,
    },
    Button: {
      controlHeight: 40,
      controlHeightSM: 32,
    },
  },
});
